<template>
    <div class="extensionAgent">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="推广员" name="extensionAgentCom">
                <ExtensionAgentCom ref="extensionAgentCom"></ExtensionAgentCom>
            </el-tab-pane>
            <el-tab-pane name="auditInformation">
                <div class="auditMsg" slot="label">审核信息 <span v-if="showRed"></span></div>
                <AuditInformation @auditMsg="auditMsg" @agree='agreeAudit'></AuditInformation>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import ExtensionAgentCom from './extensionAgent/extensionAgentCom'
import AuditInformation from './extensionAgent/auditInformation'
export default {
name: 'extensionAgent',
    data() {
        return {
            activeName: 'extensionAgentCom',
            showRed: false,
            agree: false
        }
    },
    methods: {
        auditMsg(v) {
            this.showRed = v
        },
        agreeAudit(v) {
            this.agree = v
        }
    },
    watch: {
        'agree': {
            handler(newV) {
                if (newV) {
                    this.$refs.extensionAgentCom.getExtensionAgentList()
                }
            }
        }
    },
    components: {
        ExtensionAgentCom, AuditInformation
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .extensionAgent{
        .el-tabs{
            .auditMsg{
                span{
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    background: #F56C6C;
                    border-radius: 50%;
                    position: relative;
                    top: -2px;
                }
            }
        }
    }
</style>